import AgentActivity from 'models/agent_activity';
import { InboxConversationStatus } from 'models/location/inbox';
import InboxView from './lib/inbox_view';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class OpenHome {
  constructor(context) {
    this.context = context;
    this.inboxView = new InboxView(context);
  }

  run({ conversationStatus, sortOrder, topicId }) {
    const appFeatures = this.context.stores.appFeatures.get();
    if (!appFeatures.isEnabled('internalAgentActions') && appFeatures.isEnabled('viewLiveboards')) {
      this.context.router.navigateToUrl('/liveboards');
      return;
    }

    if (!appFeatures.isEnabled('internalAgentActions') && appFeatures.isEnabled('kbManagement')) {
      this.context.router.navigateToUrl('/kb-admin');
      return;
    }

    this.inboxView.enter({ sortOrder, topicId }, inboxParams => createInboxParams(inboxParams, { conversationStatus }));
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.INBOX });
    this.context.analytics.track('Inbox Opened', { conversationStatus });
  }
}

function createInboxParams(inboxParams, { conversationStatus }) {
  if (!conversationStatus) {
    conversationStatus = InboxConversationStatus.OPEN;
  }

  return { ...inboxParams, conversationStatus, isTeam: false, routingGroupId: null };
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/inbox/open_home.js